import { UserNotificationDTO } from "@/src/types/types";

import { api, apiPaths } from "../../api";

export enum NotificationQueryKeys {
  NOTIFICATIONS = "notifications"
}

export const getNotifications = async (): Promise<UserNotificationDTO[]> => {
  return api
    .url(`${apiPaths.NOTIFICATIONS}`)
    .get()
    .json()
    .then((res) => res as UserNotificationDTO[])
    .catch(() => {
      return [];
    });
};

export const updateNotification = async (params: {
  notificationId: number;
  isRead: boolean;
}): Promise<UserNotificationDTO> => {
  return api
    .url(`${apiPaths.NOTIFICATIONS}/${params.notificationId}`)
    .put({ isRead: params.isRead })
    .json()
    .then((res) => res as UserNotificationDTO);
};

export const deleteNotification = async (notificationId: number) => {
  return api.url(`${apiPaths.NOTIFICATIONS}/${notificationId}`).delete().json();
};
